<template>
  <div class="lang-selection">
    <el-select
      v-if="$store.state.page.style === 'dni'"
      id="language"
      v-model="$store.state.user.user_gui_region"
      size="mini"
      @change="changeLang"
      :disabled="$store.state.user.changing_lang || $store.state.user.menu_disabled"
    >
      <el-option
        v-for="item in langs"
        :id="item.value"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <select
      v-if="$store.state.page.style !== 'dni'"
      id="language"
      v-model="$store.state.user.user_gui_region"
      name="language"
      @change="changeLang"
      :disabled="$store.state.user.changing_lang || $store.state.user.menu_disabled"
    >
      <option v-for="item in langs" :key="item.value" :value="item.value">
        {{ $t(item.label) }}
      </option>
    </select>
  </div>
</template>
<script>
export default {
  data() {
    return {
      langs: [],
      retry: {
        count: 0,
        max: 120,
        handler: null,
      },
      browser: "",
      target: "",
    };
  },
  async mounted() {
    await this.init();
  },
  methods: {
    async init() {
      this.langs = await this.$store.dispatch("user/getSupportedLangs");
      this.browser = this.utils.getBrowserLang();
      if (
        this.$store.state.user.user_gui_region == "Auto" &&
        this.browser != this.$store.state.user.gui_region
      ) {
        await this.changeLang();
      } else {
        this.checkAdt();
      }
    },
    async checkAdt() {
      if (!this.$store.getters.supportAutoTimezone) {
        return;
      }
      if (!this.$store.state.user.never_remind_adt) {
        const ntpRet = await this.$api.get("ntpSettings");
        let ntpList = [];
        if (ntpRet && ntpRet.code == 0) {
          ntpList = ntpRet.data.info.timezone_list;
        } else {
          return;
        }
        const pcTz = this.utils.getPcTz(ntpList);
        if (pcTz && pcTz != ntpRet.data.settings.timezone_keyword) {
          if (
            this.utils.confirmBox(
              this.$t("auto_timezone_title") + "\n" + this.$t("auto_timezone_msg"),
            )
          ) {
            await this.$api.post("adt", { timezone: pcTz });
          }
          this.$store.dispatch("user/setAdt", true);
        }
      }
    },
    // async loadLocaleLanguage() {
    //   const ret = await this.$api.get("locale");
    //   let lang = {};
    //   if (ret && ret.code == 0 && ret.data) {
    //     lang = ret.data;
    //   }
    //   const baseLang = this.$i18n.getLocaleMessage("English");
    //   const local = this.$i18n.getLocaleMessage(this.$store.state.user.gui_region);
    //   const exist = Object.assign({}, baseLang, local, lang);
    //   this.$i18n.setLocaleMessage(this.$store.state.user.gui_region, exist);
    //   this.$store.state.user.changing_lang = false;
    // },
    async getChangeStatus() {
      if (!this.$store.state.user.changing_lang) {
        clearTimeout(this.retry.handler);
        return;
      }
      clearTimeout(this.retry.handler);
      this.retry.count++;
      if (this.retry.count < this.retry.max) {
        this.retry.handler = setTimeout(
          async function () {
            const sRet = await this.$api.post(
              "lang",
              {
                action: "get_lang_status",
                name: this.$store.state.user.user_gui_region,
                target: this.target,
              },
              false,
              "",
              false,
            );
            if (sRet.data.language_switch_status == "running") {
              this.getChangeStatus();
              if (sRet.data.language_download_status.includes("%")) {
                let percent = parseInt(sRet.data.language_download_status, 10);
                if (percent == 0) {
                  percent = parseInt((this.retry.count * 100) / this.retry.max, 10);
                  if (percent == 0) percent = this.retry.count;
                }
                this.$store.dispatch("page/setLoadingStyle", [true, percent, ""]);
              }
            } else if (sRet.data.language_switch_status == "finished") {
              if (sRet.data.language_download_status == "100%") {
                await this.$store.dispatch("page/setLoadingStyle", [true, 100, ""]);
                await this.$store.dispatch("user/setLang", this.target);
                await this.$store.dispatch("page/setLoadingStyle", [false, 0, ""]);
                this.$store.state.user.changing_lang = false;
                this.$store.state.user.menu_disabled = false;
                this.$store.state.user.change_lang_stage = "";
                await this.$store.dispatch("user/loadLocaleLanguage");
                this.checkAdt();
              } else {
                this.utils.alertBox(this.$t("ml_failDownload"));
                this.cancelChangeLang();
              }
            } else if (sRet.data.language_switch_status == "no_internet") {
              this.utils.alertBox(this.$t("ml_noInternet"));
              this.cancelChangeLang();
            } else if (sRet.data.language_switch_status == "server_unreachable") {
              this.utils.alertBox(this.$t("serv_unreachable"));
              this.cancelChangeLang();
            } else if (sRet.data.language_switch_status == "download_failed") {
              this.utils.alertBox(this.$t("ml_failDownload"));
              this.cancelChangeLang();
            }
          }.bind(this),
          1000,
        );
      } else {
        this.utils.alertBox(this.$t("ml_failDownload"));
        this.cancelChangeLang();
      }
    },
    async changeLang() {
      this.$store.state.user.menu_disabled = true;
      this.target = this.$store.state.user.user_gui_region;
      if (this.target == "Auto") {
        this.target = this.browser;
      }
      this.retry.count = 0;

      const ret = await this.$api.post("lang", {
        action: "check_exist",
        name: this.utils.transferValue2Config(
          "lang",
          "lang",
          this.$store.state.user.user_gui_region,
        ),
        target: this.target,
      });
      this.$store.state.user.changing_lang = true;
      if (ret && ret.code == 0 && ret.data) {
        if (ret.data.code == 100) {
          this.$store.state.user.change_lang_stage = "process";
          await this.$store.dispatch("page/setLoadingStyle", [true, 0, ""]);
          await this.getChangeStatus();
        } else if (ret.data.code == 200) {
          this.$store.state.user.changing_lang = false;
          this.$store.state.user.menu_disabled = false;
          this.$store.state.user.change_lang_stage = "";
        } else {
          this.$store.state.user.change_lang_stage = "confirm";
        }
      } else {
        this.utils.alertBox(this.$t("ml_failDownload"));
        this.cancelChangeLang();
      }
    },
    async switchLang() {
      const ret = await this.$api.post("lang", {
        action: "switch",
        name: this.utils.transferValue2Config(
          "lang",
          "lang",
          this.$store.state.user.user_gui_region,
        ),
        target: this.target,
      });
      if (ret && ret.code == 0 && ret.data && ret.data.code == 100) {
        this.$store.state.user.change_lang_stage = "process";
        this.$store.dispatch("page/setLoadingStyle", [true, 0, ""]);
        await this.getChangeStatus();
      } else {
        this.utils.alertBox(this.$t("ml_failDownload"));
        this.cancelChangeLang();
      }
    },
    async cancelChangeLang() {
      const ret = await this.$api.post("lang", { action: "cancel" }, false, "", false);
      this.$store.state.user.changing_lang = false;
      this.$store.state.user.menu_disabled = false;
      this.$store.state.user.change_lang_stage = "";
      if (ret && ret.code == 0) {
        this.$store.state.user.user_gui_region = this.utils.transferConfig2Value(
          "lang",
          "lang",
          ret.data.user_select,
        );
      } else {
        this.$store.state.user.user_gui_region = this.$store.state.user.gui_region;
      }
      this.checkAdt();
    },
  },
};
</script>
<style lang="scss">
@import "~@/styles/variables.scss";
.lang-selection {
  float: left;
  .el-select {
    line-height: $topBarFontSize;
  }
  select {
    background-color: rgba(255, 255, 255, 0.9);
    width: auto;
    padding: 0 10px;
    border: solid 1px #f2f2f2;
    height: auto;
    max-width: 500px;
    font-size: 15px;
  }
  select:focus {
    outline: 0;
  }
}
</style>
